import { render } from "./EditTypeRamification.vue?vue&type=template&id=31ed0a55"
import script from "./EditTypeRamification.vue?vue&type=script&lang=js"
export * from "./EditTypeRamification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__